var _style, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnGb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 335",
    width: 512,
    height: 335,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\ttspan { white-space:pre }\r\n\t\t.shp0 { fill: #41479b } \r\n\t\t.shp1 { fill: #f5f5f5 } \r\n\t\t.shp2 { fill: #ff4b55 } \r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M503.17 335.73L8.83 335.73C3.95 335.73 0 331.77 0 326.9L0 9.1C0 4.23 3.95 0.28 8.83 0.28L503.17 0.28C508.05 0.28 512 4.23 512 9.1L512 326.9C512 331.77 508.05 335.73 503.17 335.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp1",
    d: "M512 9.1C512 4.23 508.05 0.28 503.17 0.28L463.68 0.28L300.14 107.42L300.14 0.28L211.86 0.28L211.86 107.42L48.32 0.28L8.83 0.28C3.95 0.28 0 4.23 0 9.1L0 31.94L140.31 123.86L0 123.86L0 212.14L140.31 212.14L0 304.07L0 326.9C0 331.77 3.95 335.72 8.83 335.72L48.32 335.72L211.86 228.58L211.86 335.72L300.14 335.72L300.14 228.58L463.68 335.72L503.17 335.72C508.05 335.72 512 331.77 512 326.9L512 304.07L371.69 212.14L512 212.14L512 123.86L371.69 123.86L512 31.94L512 9.1Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp2",
    d: "M512 141.52L282.48 141.52L282.48 0.28L229.52 0.28L229.52 141.52L0 141.52L0 194.48L229.52 194.48L229.52 335.73L282.48 335.73L282.48 194.48L512 194.48L512 141.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp2",
    d: "M178.95 212.14L0.25 328.13C0.88 332.4 4.39 335.72 8.83 335.72L20.99 335.72L211.38 212.14L178.95 212.14L178.95 212.14L178.95 212.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp2",
    d: "M346.39 212.14L313.96 212.14L504.07 335.54C508.5 335.07 512 331.45 512 326.9L512 319.64L346.39 212.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp2",
    d: "M0 18.85L161.78 123.86L194.21 123.86L5.14 1.14C2.12 2.54 0 5.56 0 9.1L0 18.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp2",
    d: "M332.57 123.86L511.69 7.59C510.95 3.46 507.51 0.28 503.17 0.28L490.52 0.28L300.14 123.86L332.57 123.86Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnGb);
export default __webpack_public_path__ + "static/media/en-GB.c6c3a0f7fa5b04e954e06bf4ec50c438.svg";
export { ForwardRef as ReactComponent };